import {
	Directive,
	HostListener,
	Input
}                    from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive( {
	selector: '[appFormControlTrim]'
} )
export class FormControlTrimDirective {


	@Input() public disableTrim = false;
	@Input() public alwaysTrim = false;

	constructor(
		private ngControl: NgControl
	) {}

	@HostListener( 'input', [ '$event.target.value' ] )
	onInput( inputValue: string ): void {
		if ( !this.disableTrim && inputValue && inputValue.length > 0 ) {

			const trimmed = this.alwaysTrim
											? inputValue.trim()
											// @ts-ignore
											: inputValue.trimStart();


			this.applyTrim( trimmed );
		}
	}

	@HostListener( 'blur', [ '$event.target.value' ] )
	onBlur( inputValue: string ): void {
		if ( !this.disableTrim && inputValue && inputValue.length > 0 ) {
			this.applyTrim( inputValue.trim() );
		}
	}

	applyTrim( trimmedValue: string ): void {
		if ( !this.ngControl?.control ) { return; }

		if ( trimmedValue.length === 0 ) {
			this.ngControl.control.reset();
		} else {
			this.ngControl.control.setValue( trimmedValue );
		}
		// Be aware that this could affect some of our fancy stuff like custom multi-field Validators :-) e.g. no-duplicate-emails.ts or required-language.ts
		// DISCLAIMER: Don't delete. This sentence is very valuable, this knowledge took me almost 2 days of debugging
		this.ngControl.control.updateValueAndValidity();
	}
}
